export default class Color {

  constructor(r, g, b, a = 1) {
    if (typeof r == "string") {
      const parts = r.match(/[0-9\.]+/g)
      r = parseInt(parts[0])
      g = parseInt(parts[1])
      b = parseInt(parts[2])
      a = parts[3] != null ? parseFloat(parts[3]) : 1
    }

    this.r = r
    this.g = g
    this.b = b
    this.a = a
  }

  static get contextTypes() {
    return super.contextTypes
  }


  toString(radix) {
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`
  }
}
